<div ngbDropdown class="d-inline-block">
	<button class="btn btn-link btn-lang-switch" *ngIf="languageOptions && (currentLanguage | async)" id="languageSwitch" ngbDropdownToggle>
		{{ languageOptions[(currentLanguage | async)] }}
	</button>
	<div ngbDropdownMenu aria-labelledby="languageSwitch">
		<ng-container *ngFor="let language of objectKeys(languageOptions)">
			<button class="dropdown-item" [ngClass]="{ active: (currentLanguage | async) === language }" (click)="setLanguage(language)">
				{{ languageOptions[language] }}
			</button>
		</ng-container>
	</div>
</div>
